import { Popover, PopoverProps } from "antd";
import styles from "./style.module.scss";
import { TooltipPlacement } from "antd/es/tooltip";
import classNames from "classnames";

interface VLPopoverProps extends PopoverProps {
  content?: React.ReactNode;
  children: React.ReactNode;
  trigger?: VLPopoverTrigger;
  title?: string;
  placement?: TooltipPlacement;
  overlayClassName?: string;
  bordered?: boolean;
}
type VLPopoverTrigger = "hover" | "click" | "focus";

export default function VLPopover({
  content,
  children,
  trigger,
  placement = "top",
  overlayClassName,
  bordered,
  ...rest
}: VLPopoverProps) {
  return (
    <Popover
      content={
        content ? (
          <div className={styles.popoverContent}>{content}</div>
        ) : undefined
      }
      placement={placement}
      trigger={trigger}
      overlayClassName={classNames(styles.popover, overlayClassName, {
        [styles.bordered]: bordered,
      })}
      {...rest}
    >
      <div className={styles.popoverButton}>{children}</div>
    </Popover>
  );
}
